import styled from '@emotion/styled';
import Skeleton from 'components/base/Skeleton';
import { HEADER_HEIGHT } from 'styles/layout';

/**
 * 상품카드 - Skeleton
 * @component
 */
const CompletedSkeleton = () => {
  return (
    <SC.Container>
      <SC.Title>
        <div className='title'>
          <Skeleton width={92} height={20} radius={2} />
          <Skeleton width={13} height={18} radius={2} />
        </div>
        <Skeleton width={106} height={18} radius={2} />
      </SC.Title>
      <SC.ReviewCard>
        <div className='product_img'>
          <Skeleton width={64} height={64} radius={4} />
        </div>
        <div className='product_info'>
          <Skeleton width={263} height={19} radius={2} className='mb' />
          <Skeleton width={79} height={17} radius={2} />
          <Skeleton width={180} height={18} radius={2} />
          <Skeleton width={263} height={36} radius={4} />
        </div>
      </SC.ReviewCard>
    </SC.Container>
  );
};

export default CompletedSkeleton;

const SC = {
  Container: styled.div`
    height: 100%;
    padding: 94px 16px 0;
    padding-top: ${HEADER_HEIGHT}px;
  `,
  Title: styled.div`
    padding: 14px 0 18px;
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      * + * {
        margin-left: 4px;
      }
    }
  `,
  ReviewCard: styled.div`
    display: flex;

    .product_img {
      margin-right: 12px;
    }
    .product_info {
      > * + * {
        margin-top: 2px;
        margin-bottom: 6px;
      }
      > * + * + * {
        margin-bottom: 12px;
      }
    }
  `,
};
